module.exports = __webpack_public_path__ + "static/media/Opened.6cef7efd.svg";